import { BreadcrumbsHeader } from 'components/molecules/BreadcrumbsHeader';
import { RepresentativeShareLink } from 'components/molecules/Representative/RepresentativeShareLink';
import { ConvertedPartners } from 'components/organisms/Representative/ConvertedPartners';
import { RepresentativeData } from 'components/organisms/Representative/RepresentativeData';
import { RepresentativeDocuments } from 'components/organisms/Representative/RepresentativeDocuments';
import { useRepresentative } from 'hooks/useRepresentative';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Grid } from '@mui/material';

export const RepresentativeView: React.FC = () => {
  const { representativeId } = useParams<{ representativeId: string }>();
  const { getRepresentative, representative } = useRepresentative();

  useEffect(() => {
    getRepresentative(representativeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [representativeId]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <BreadcrumbsHeader
          items={[
            { title: 'Representantes' },
            { title: 'Resumo Dados do Representante' },
          ]}
        />
      </Grid>

      <Grid container item xs={12} mt={1} spacing={4}>
        <Grid item xs={12}>
          <RepresentativeData representant={representative} />
        </Grid>
        <Grid item xs={12}>
          <ConvertedPartners />
        </Grid>

        <Grid item container>
          <Grid item xs>
            {representative?.documents && (
              <RepresentativeDocuments
                idRepresentant={representative._id}
                documents={representative?.documents}
              />
            )}
          </Grid>

          <Grid item xs={5}>
            <RepresentativeShareLink
              representantUrl={representative?.representantUrl}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

